<template>

<div class="main-page-content">
    <div class="container">
        <div class="row d-flex justify-content-center">
            
            <loading-div v-if='!isReady'></loading-div>

            <div v-if='isReady' class="col-md-10">
                <div class="card calculator-calc">
                    <div class="pt-4 pl-4 pr-4 pb-2 p-lg-5">
                        <div class="row">
                            <div class="col-12">
                                <h2 class="text-center orange-txt mb-2">Калкулатор</h2>
                                <p class="text-center text-big mb-4">
                                    Калкулаторът изчислява минималната цена и срок за Вашия проект.
                                </p>
                            </div>
                        </div>

                        <div class="row d-flex align-items-center pl-4 pr-4 pt-4 pb-3">
                            <div class="col-xl-4">
                                <div class="calculator-question d-flex align-items-center mb-2 mb-xl-0">
                                   <span class="num">1.</span>
                                   <span class="text">Какъв тип е обектът?</span>
                                </div>
                            </div>

                            <div class="col-xl-8 d-flex flex-column flex-lg-row align-items-center justify-content-between">

                                <div v-for='t in types' 
                                     @click='setType(t)' 
                                     class="custom-control custom-radio custom-radio-border mb-2 mr-2 ml-2 flex-grow-lg-1 w-100">
                                    
                                    <input type="radio" :id='"t-" + t.id' 
                                            name="type-select" 
                                            class="custom-control-input">
                                    
                                    <label class="custom-control-label w-100" :for="'t-' + t.id">
                                        {{ t.name }}
                                    </label>
                                </div>

                            </div>
                        </div>


                        <div id="subType" :class="[ '', { 'visible' : type }]">

                            <div class="p-4 row d-flex align-items-center gray-row mb-4">
                                <div class="col-xl-4">
                                    <div class="calculator-question">                         
                                       <label for="object-subtype" class="text">Подтип на обекта:</label>
                                    </div>
                                </div>

                                <div class="col-xl-8 d-flex align-items-center justify-content-end">
                                    <select id="object-subtype" v-model='subType' class="custom-select custom-select-lg">
                                        <option :value='false'>Изберете под-тип</option>
                                        <option v-for='st in subTypes[ type ]' :value='st.id'>{{ st.name }}</option>
                                    </select>
                                </div>
                            </div>

                        </div>

                        <hr class="mt-lg-3 mt-4 mb-4" />

                         <div class="row d-flex align-items-center pl-4 pr-4 pb-3">
                            <div class="col-xl-4">
                                <div class="calculator-question d-flex align-items-center mb-2 mb-xl-0"> 
                                   <span class="num">2.</span>
                                   <span class="text">Каква е квадратурата?</span>
                                </div>
                            </div>

                            <div class="col-xl-8">

                                <div class="input-group pr-2 pl-2 mb-3">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <span class="icon icon-maximize"></span>
                                        </div>
                                    </div> 
                                    <input id='qd' class="form-control input-lg"
                                            v-model.number='quadrature'
                                            type='number'>
                                </div>

                                  <!--   <div v-for='q in quads' class="col-md-3 col-sm-6 mb-3 pr-0">
                                        <div class="custom-control custom-radio custom-radio-box">
                                            <input type="radio" class="custom-control-input"
                                                   :id="'quad-' + q.id" 
                                                   name="object-type2" >
                                            <label class="custom-control-label w-100" :for="'quad-' + q.id">
                                                <span class="icon icon-maximize squaring-xs d-block mb-1"></span>
                                                <span class="text">{{ q.name }}<sup>2</sup></span>
                                            </label>
                                        </div>
                                    </div> -->

                            </div>
                        </div>
                    </div>

                    <div class="gray-bck pt-3 pb-3">
                        <div class="row">
                            <div class="col-12">
                                <h4 class="text-center">Параметри за целия проект</h4>
                            </div>
                        </div>
                        <div class="row calculator-result d-flex justify-content-center">
                            <div class="col-lg-5 calculator-first-result pt-2 pb-3 pt-lg-4 pb-lg-4">
                                <div class="d-flex align-items-center justify-content-left pl-5">
                                    <span class="icon icon-wallet"></span>
                                    <span class="text">
                                        <h4>Бюджет на проекта</h4>
                                        <span class="calc">{{ getCost }}лв.</span>
                                    </span>
                                </div>                                
                            </div>

                            <div class="col-lg-5 pt-3 pb-2 pt-lg-4 pb-lg-4">
                                <div class="d-flex align-items-center justify-content-left pl-5">
                                    <span class="icon icon-calendar-light"></span>
                                    <span class="text">
                                        <h4>Срок на проекта</h4>
                                        <span class="calc">{{ getTime }} дни</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>   

                    <div class="gray-bck pt-3 pb-3">
                        <div class="row">
                            <div class="col-12">
                                <h4 class="text-center bpt">Параметри за изработка на Идеен проект</h4>
                            </div>
                        </div>
                        <div class="row calculator-result d-flex justify-content-center">
                            <div class="col-lg-5 calculator-first-result pt-2 pb-3 pt-lg-4 pb-lg-4">
                                <div class="d-flex align-items-center justify-content-left pl-5">
                                    <span class="icon icon-wallet"></span>
                                    <span class="text">
                                        <h4>Цена за Идеен проект</h4>
                                        <span class="calc">{{ getCostIP }}лв. </span>
                                        <small class="d-block">без ДДС</small>
                                    </span>
                                </div>                                
                            </div>

                            <div class="col-lg-5 pt-3 pb-2 pt-lg-4 pb-lg-4">
                                <div class="d-flex align-items-center justify-content-left pl-5">
                                    <span class="icon icon-calendar-light"></span>
                                    <span class="text">
                                        <h4>Време за изработка на Идеен проект</h4>
                                        <span class="calc">{{ getTimeIP }} дни</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>   

                </div>

                <div class="row">
                    <div class="col-12 text-center mt-4 mt-xl-5">
                        <a href="/add-project" class="btn btn-primary btn-lg">
                            <span class="icon icon-plus-circle"></span>
                            Създай проект
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {
           
        },

        data() {
            return {
                isReady : false,

                types    : [],
                subTypes : {},
                quads    : [], 
                quadrature : null,
                coefs    : false,

                type : false,
                subType : false,
                quad : false,

                total : false,
            }
        },

        methods : {

            getData() {
                var me = this;

                me.ajax.call('clc:gt', {}, (r) => {

                    if( r.status == 'success' ) {

                        me.quads = r.data.q;
                        me.types = r.data.t;
                        me.coefs = r.data.c;

                        for( var i in me.types ) {

                            me.subTypes[ me.types[i].id ] = [];

                            for( var j in me.types[i].sub_types ) {
                                me.subTypes[ me.types[i].id ].push( me.types[i].sub_types[j] );
                            }

                        }

                        me.isReady = true;
                    }

                })
            },

            setType( t ) {
                this.type = t.id;
                this.subType = false;
            }

        },

        computed : {

            getCost() {
                if( !this.quad || !this.subType ) {
                    return 0;
                }

                var A = this.findKey( this.subTypes[ this.type ], 'id', this.subType ), 
                    B = this.findKey( this.quads, 'id', this.quad );

                return this._cf.cost(A,B,this.coefs,this.quadrature);
            },

            getTime() {
                if( !this.quad || !this.subType ) {
                    return 0;
                }
                
                var A = this.findKey( this.subTypes[ this.type ], 'id', this.subType ), 
                    B = this.findKey( this.quads, 'id', this.quad );

                return parseInt( A.coef_time * B.coef_time * this.coefs.bt );
            },

            getCostIP() {
                if( !this.quad || !this.subType ) {
                    return 0;
                }

                var A = this.findKey( this.subTypes[ this.type ], 'id', this.subType ), 
                    B = this.findKey( this.quads, 'id', this.quad );

                return this._cf.costIP(A, B, this.coefs, false, this.quadrature);
            },

            getTimeIP() {
                if( !this.quad || !this.subType ) {
                    return 0;
                }
                
                var A = this.findKey( this.subTypes[ this.type ], 'id', this.subType ), 
                    B = this.findKey( this.quads, 'id', this.quad );

                return parseInt( A.coef_time_ip * B.coef_time_ip * this.coefs.bti );
            }
        
        },

        watch : {

            quadrature( n, o ) {

                for( var i in this.quads ) {
                    if( n > this.quads[i].size_from && n <= this.quads[i].size_to ) {
                        this.quad = this.quads[i].id;
                        break;
                    }
                }

            }

        }

    }
</script>
